import styled from '@emotion/styled';

import { IconLoading, usePreventScroll } from '@myrealtrip/web-ui';

interface Props {
  isPending: boolean;
}

const SearchLoading = ({ isPending }: Props) => {
  usePreventScroll({ isDisabled: !isPending });

  return (
    <LoadingContainer>
      <StyledIconLoading
        preventScrollProps={{ ignoreIosScroll: true, ignoreScrollBarArea: true }}
      />
    </LoadingContainer>
  );
};

export default SearchLoading;

const LoadingContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: ${({ theme }) => theme.zIndex.top};
`;

const StyledIconLoading = styled(IconLoading)`
  position: relative;

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background: ${({ theme }) => theme.colors.white};
    opacity: 0.3;
    pointer-events: none;
  }

  img {
    position: relative;
    opacity: 1;
  }
`;
